import * as SharedAcross from '../utilities/SharedAcross';
import { Icon } from '@iconify/react';

function App(props) {

  var options = props.options;
  var currentAnswer = props.currentAnswer;
  var onClick = props.onClick;

  function onClickX(aCell){
    return function(e) {
      onClick(aCell);
    }
  }

  var baselineGridCols = 3;
  if (options.length === 2){
    baselineGridCols = 2;
  }

   var grid = SharedAcross.convertToGrid(options, baselineGridCols, false);
   var r = grid.map((aGrid, indexX)=>{
    var inside = aGrid.map((aCell, index)=>{
      if (aCell){
        var classButton = 'btn epillchoice';
        
        if (index !== 0){
          classButton += ' removeLeftBorder';
        }
        if (indexX > 0){
          classButton += ' removeTopBorder';
        }
        if (currentAnswer === aCell.i){
          classButton += ' epillchoiceSelected';
        }
        var className = '';
        if (aCell.h){
          className += ' elementsqtip tip-bottom';              
        }

        var vFlip = false;
        if (aCell.vFlip){
          vFlip = true;
        }

        var rotate = '0';
        if (aCell.rotate){
          rotate = aCell.rotate;
        }
        var style = {};
        if (baselineGridCols === 2){
          style.width = '100px';
        }

        // 
        return <div className={className} data-tip={aCell.h} onClick={onClickX(aCell)} ><div className={classButton} style={style}><div ><Icon width = '20' icon={aCell.ic} vFlip={vFlip} rotate={rotate} /></div>
          <div>{aCell.t}</div></div></div>
      }else{
        return null;
      }
    })

    return <div key={indexX} className='btn-group'>{inside}</div>
   })
  return <center>{r}</center>
}

//
export default App;
